import React from 'react';
import './HardeningImprovementsCard.css';

const HardeningImprovementsCard = ({ scanData }) => {
  const hardening = scanData?.hardening || {};
  const securityHeaders = scanData?.security_headers || {};
  
  const improvements = [
    {
      type: 'protection',
      title: 'Protection',
      issues: hardening.firewall_detected === false ? [
        {
          message: 'No website application firewall detected. Please install a cloud-based WAF to',
          highlight: 'prevent website hacks and DDoS attacks'
        }
      ] : []
    },
      {
        type: 'security_headers',
        title: 'Security Headers',
        issues: [
          ...(securityHeaders.x_frame_options === false ? [{
            message: 'Missing security header for ClickJacking Protection. Alternatively, you can use',
            highlight: "Content-Security-Policy: frame-ancestors 'none'",
            affectedPages: securityHeaders.affected_pages || []
          }] : []),
          ...(securityHeaders.x_content_type_options === false ? [{
            message: 'Missing security header to prevent Content Type sniffing.',
            highlight: '',
            affectedPages: securityHeaders.affected_pages || []
          }] : []),
          ...(securityHeaders.strict_transport_security === false ? [{
            message: 'Missing',
            highlight: 'Strict-Transport-Security security header',
            affectedPages: securityHeaders.affected_pages || []
          }] : []),
          ...(securityHeaders.content_security_policy === false ? [{
            message: 'Missing',
            highlight: 'Content-Security-Policy directive',
            subMessage: 'We recommend to add the following CSP directives (you can use default-src if all values are the same): script-src, object-src, base-uri, frame-src'
          }] : []),
          ...(securityHeaders.server_banner_exposed === true ? [{
            message: 'Default server banners displayed.',
            highlight: 'Your site is displaying your web server default banners'
          }] : [])
        ]
      }
  ];

  return (
    <div className="hardening-improvements-card">
      <div className="card-header">
        <h3>Hardening Improvements</h3>
      </div>
      
      {improvements.map((section, idx) => (
        section.issues.length > 0 && (
          <div key={idx} className="improvement-section">
            <div className="section-accent" />
            <div className="section-content">
              <h4 className="section-title">{section.title}</h4>
              {section.issues.map((issue, issueIdx) => (
                <div key={issueIdx} className="improvement-item">
                  <p className="improvement-text">
                    {issue.message}{' '}
                    <span className="highlight-text">{issue.highlight}</span>
                    {issue.subMessage && (
                      <>
                        . {issue.subMessage}
                      </>
                    )}
                  </p>
                  {issue.affectedPages && issue.affectedPages.length > 0 && (
                    <div className="affected-pages">
                      Affected pages: {issue.affectedPages.join(', ')}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )
      ))}
      
      {improvements.every(s => s.issues.length === 0) && (
        <div className="no-improvements">
          <p>No hardening improvements needed at this time.</p>
        </div>
      )}
    </div>
  );
};

export default HardeningImprovementsCard;

